import React, { useState } from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import BackButton from "../../../components/BackButton/index.js";
import { Box, Container, Typography } from "@mui/material";
import ReactCodeInput from "react-code-input";
import appcolors from "../../../constants/Colors.js";
import { useNavigate } from "react-router-dom";
import Label from "./../../../components/Label/index";
import GlobalButton from "../../../components/CustomButton/index.js";

const props = {
  inputStyle: {
    fontFamily: "Inter",
    // margin: "10px",
    MozAppearance: "textfield",
    width: "40px",
    borderRadius: "2px",
    fontSize: "14px",
    height: "45px",
    textAlign: "center",
    color: appcolors.black,
    border: `1px solid ${appcolors.slateGrey}`,
  },
};

function Forgotverification() {
  const navigate = useNavigate();
  // States
  const [code, setCode] = useState("");
  return (
    <AuthContainer>
      <Box position={"absolute"} top={30} left={15}>
        <BackButton />
      </Box>
      <Container sx={{ maxWidth: "550px !important" }}>
        <Typography variant="auth_primary" component={"h1"}>
          Verification process
        </Typography>
        <Typography variant="auth_secondary" component={"p"} sx={{ mt: 0.5 }}>
          We send it the 6 digit code on your company email address please enter
          the code
        </Typography>

        <Container maxWidth="xs">
          <Box
            sx={{ margin: { xs: "2rem 0", md: "3rem 0" } }}
            className={"react-cvi"}
          >
            <Label labelText="Enter 6 digit code" />
            <ReactCodeInput
              type="number"
              value={code}
              onChange={(e) => {
                setCode(e);
              }}
              fields={6}
              {...props}
            />
          </Box>
          <Box mt={5}>
            <GlobalButton
              variant={"contained"}
              btnText={"Next"}
              handleClickBtn={() => navigate("/reset-password")}
            />
          </Box>
        </Container>
      </Container>
    </AuthContainer>
  );
}

export default Forgotverification;
